import { useSelector } from 'react-redux';
import { ProfileField } from '../types/profile';
import { RootState } from '../types/redux';

export default function useProfileFields(): ProfileField[] {
  return useSelector((state: RootState): ProfileField[] => state.application.profileFields || []);
}
